import { motion } from 'motion/react'
import { PlatformMarketingCard } from '../groupPlatformItems'
import { LandingSection } from '../LandingSection'

export function BenefitsSection({ items }: { items: PlatformMarketingCard[] }) {
  return (
    <LandingSection className="bg-offwhite" eyebrow="Platform" title="Benefits">
      <div className="grid gap-8 sm:grid-cols-2">
        {items.map((item, index) => (
          <motion.article
            key={item.card.id || item.card.title}
            className="border-l-2 border-primary pl-5"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.45, delay: index * 0.05 }}
          >
            {item.card.subtitle && <p className="mb-2 text-sm text-muted-foreground">{item.card.subtitle}</p>}
            <h3 className="text-xl font-semibold text-foreground">{item.card.title}</h3>
            <p className="mt-3 leading-relaxed text-muted-foreground">{item.card.description}</p>
          </motion.article>
        ))}
      </div>
    </LandingSection>
  )
}
